<template>
    <v-container>
        <div class="d-flex align-center gap-10 mt-5">
            <v-btn icon variant="text" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <div class="font-weight-600 font-size-24 text-blacknew">
                Beli Paket
            </div>
        </div>

        <div v-if="loading" class="text-center py-10">
            <v-progress-circular
                color="#0e97d6"
                indeterminate
                size="50"
                width="6"
            ></v-progress-circular>
        </div>

        <v-row v-if="!loading" class="mt-2">
            <v-col :class="{ 'sticky-col': display.mdAndUp.value }">
                <card-package v-if="detail" :data="detail" />
            </v-col>

            <v-col>
                <v-form ref="form" v-model="isFormValid">
                    <v-card variant="flat" rounded="10" class="border-1">
                        <v-card-text>
                            <v-expansion-panels
                                v-model="activePanel"
                                variant="accordion"
                                class="border-1 rounded-8"
                            >
                                <v-expansion-panel
                                    value="panel1"
                                    class="rounded-8"
                                >
                                    <v-expansion-panel-title>
                                        <span class="font-weight-600">
                                            Detail Pembeli
                                        </span>
                                    </v-expansion-panel-title>

                                    <v-expansion-panel-text>
                                        <div class="py-3">
                                            <div class="font-size-14">
                                                Nama Siswa
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="form.student_name"
                                                    variant="flat"
                                                    placeholder="Masukkan nama siswa"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="error"
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Nama siswa wajib diisi',
                                                    ]"
                                                    required
                                                />
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Nomor WhatsApp Siswa
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="form.student_phone"
                                                    variant="flat"
                                                    placeholder="Masukkan nomor whatsapp siswa"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="primary"
                                                    maxlength="16"
                                                    type="tel"
                                                    @keypress="onlyNumber"
                                                    @input="
                                                        normalizeWaNumber(
                                                            'student_phone'
                                                        )
                                                    "
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Nomor whatsapp siswa wajib diisi',
                                                    ]"
                                                >
                                                    <template
                                                        v-slot:prepend-inner
                                                    >
                                                        <span
                                                            class="text-darkgrey"
                                                        >
                                                            +62
                                                        </span>
                                                    </template>
                                                </v-text-field>
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Nama Orang Tua
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="form.parent_name"
                                                    variant="flat"
                                                    placeholder="Masukkan nama orang tua"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="primary"
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Nomor orang tua wajib diisi',
                                                    ]"
                                                />
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Email Orang Tua
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="form.parent_email"
                                                    variant="flat"
                                                    placeholder="Masukkan email orang tua"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="primary"
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Email orang tua wajib diisi',
                                                        (v) =>
                                                            /.+@.+\..+/.test(
                                                                v
                                                            ) ||
                                                            'Format email tidak valid, pastikan email sesuai. Invoice akan dikirim ke email ini.',
                                                    ]"
                                                />
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Nomor WhatsApp Orang Tua
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="form.parent_wa"
                                                    type="tel"
                                                    variant="flat"
                                                    placeholder="Masukkan nomor whatsapp orang tua"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="primary"
                                                    maxlength="16"
                                                    @keypress="onlyNumber"
                                                    @input="
                                                        normalizeWaNumber(
                                                            'parent_wa'
                                                        )
                                                    "
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Nomor whatsapp orang tua wajib diisi',
                                                    ]"
                                                >
                                                    <template
                                                        v-slot:prepend-inner
                                                    >
                                                        <span
                                                            class="text-darkgrey"
                                                        >
                                                            +62
                                                        </span>
                                                    </template>
                                                </v-text-field>
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Nama Sekolah Siswa
                                                <span class="required">*</span>
                                            </div>
                                            <div class="mt-2">
                                                <v-text-field
                                                    v-model="
                                                        form.student_school_name
                                                    "
                                                    variant="flat"
                                                    placeholder="Masukkan nama sekolah siswa"
                                                    density="compact"
                                                    class="bg-white custom-input custom-error"
                                                    color="primary"
                                                    :rules="[
                                                        (v) =>
                                                            !!v ||
                                                            'Nama sekolah siswa wajib diisi',
                                                    ]"
                                                />
                                            </div>

                                            <div>
                                                <v-row>
                                                    <v-col cols="12" md="6">
                                                        <div
                                                            class="font-size-14 mt-1"
                                                        >
                                                            Jenjang
                                                            <span
                                                                class="required"
                                                            >
                                                                *
                                                            </span>
                                                        </div>
                                                        <div class="mt-2">
                                                            <v-select
                                                                v-model="
                                                                    form.level
                                                                "
                                                                :items="levels"
                                                                item-title="text"
                                                                item-value="id"
                                                                variant="flat"
                                                                class="bg-white custom-input custom-error"
                                                                density="compact"
                                                                placeholder="Pilih jenjang"
                                                                outlined
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        'Jenjang wajib diisi',
                                                                ]"
                                                            />
                                                        </div>
                                                    </v-col>

                                                    <v-col cols="12" md="6">
                                                        <div
                                                            class="font-size-14 mt-1"
                                                        >
                                                            Kelas
                                                            <span
                                                                class="required"
                                                            >
                                                                *
                                                            </span>
                                                        </div>
                                                        <div class="mt-2">
                                                            <v-select
                                                                v-model="
                                                                    form.grade
                                                                "
                                                                :items="grades"
                                                                variant="flat"
                                                                class="bg-white custom-input custom-error"
                                                                density="compact"
                                                                placeholder="Pilih kelas"
                                                                outlined
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        'Kelas wajib diisi',
                                                                ]"
                                                            />
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </div>

                                            <div class="font-size-14 mt-1">
                                                Sumber Informasi Pendaftaran
                                            </div>
                                            <div class="mt-2">
                                                <v-select
                                                    v-model="
                                                        form.register_information_source
                                                    "
                                                    :items="sources_information"
                                                    variant="flat"
                                                    class="bg-white custom-input custom-error"
                                                    density="compact"
                                                    placeholder="Pilih sumber informasi"
                                                    outlined
                                                />
                                            </div>
                                        </div>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel
                                    v-if="list_liveclass_schedulle.length"
                                    value="panel2"
                                    class="rounded-8"
                                    @click="toTop()"
                                >
                                    <v-expansion-panel-title>
                                        <span class="font-weight-600">
                                            Pilih Jadwal Live Class
                                        </span>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="pb-0">
                                        <v-radio-group
                                            v-model="liveclass_schedulle"
                                            color="#0e97d6"
                                            class="custom-radio"
                                        >
                                            <v-radio
                                                v-for="(
                                                    radio, i
                                                ) in list_liveclass_schedulle"
                                                :key="i"
                                                :value="radio.id"
                                                class="mt-4 items-start"
                                            >
                                                <template v-slot:label>
                                                    <div class="pl-2">
                                                        <div
                                                            class="text-blacknew font-size-14"
                                                        >
                                                            {{
                                                                radio.description
                                                            }}
                                                        </div>

                                                        <div
                                                            class="text-darkgrey font-size-14"
                                                        >
                                                            {{
                                                                $moment(
                                                                    radio.start_time
                                                                ).format(
                                                                    'HH:mm'
                                                                )
                                                            }}
                                                            -
                                                            {{
                                                                $moment(
                                                                    radio.end_time
                                                                ).format(
                                                                    'HH:mm'
                                                                )
                                                            }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <v-expansion-panel
                                    class="rounded-8"
                                    value="panel3"
                                    @click="toTop()"
                                >
                                    <v-expansion-panel-title>
                                        <span class="font-weight-600">
                                            Pilih Skema Bayar
                                        </span>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text>
                                        <v-radio-group
                                            v-model="form.payment_scheme"
                                            color="#0e97d6"
                                            class="custom-error"
                                            :rules="[
                                                (v) =>
                                                    !!v ||
                                                    'Skema bayar wajib diisi',
                                            ]"
                                        >
                                            <v-radio value="full_payment">
                                                <template v-slot:label>
                                                    <span
                                                        class="ml-2 font-size-14 text-blacknew"
                                                    >
                                                        Lunas
                                                    </span>
                                                </template>
                                            </v-radio>

                                            <v-radio
                                                value="installment_payment"
                                                disabled
                                            >
                                                <template v-slot:label>
                                                    <span
                                                        class="ml-2 font-size-14 text-blacknew"
                                                    >
                                                        Cicilan 2x
                                                    </span>
                                                </template>
                                            </v-radio>

                                            <v-radio
                                                value="dp_payment"
                                                disabled
                                            >
                                                <template v-slot:label>
                                                    <span
                                                        class="ml-2 font-size-14 text-blacknew"
                                                    >
                                                        DP 10% + Pelunasan
                                                    </span>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <v-card class="mt-4 border-1 rounded-8" flat>
                                <v-card-text>
                                    <div class="font-size-14 font-weight-600">
                                        Ringkasan Pembelian
                                    </div>
                                    <div class="mt-4">
                                        <v-row
                                            v-if="discount_status"
                                            class="text-darkgrey"
                                        >
                                            <v-col cols="12" md="7">
                                                {{ detail?.name }}
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5"
                                                class="text-right"
                                            >
                                                Rp
                                                {{
                                                    formatNumber(
                                                        detail?.normal_price
                                                    )
                                                }}
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                md="7"
                                                class="pt-0"
                                            >
                                                Potongan Harga
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5"
                                                class="text-right pt-0"
                                            >
                                                -Rp {{ package_discount || 0 }}
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            v-if="referral_status"
                                            class="text-darkgrey"
                                        >
                                            <v-col
                                                cols="12"
                                                md="7"
                                                class="pt-0"
                                            >
                                                Potongan Kode Referral
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5"
                                                class="text-right pt-0"
                                            >
                                                -Rp
                                                {{
                                                    formatNumber(
                                                        detail?.referral_discount
                                                    ) || 0
                                                }}
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <hr class="dashed my-4" />

                                    <v-row>
                                        <v-col
                                            cols="12"
                                            md="7"
                                            class="text-blacknew"
                                        >
                                            Total Pembayaran
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="5"
                                            class="text-right font-weight-600 text-chilired"
                                        >
                                            Rp
                                            {{ formatNumber(actual_price) }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>

                            <v-card class="mt-4 border-1 rounded-8" flat>
                                <v-card-text>
                                    <div class="font-size-14">
                                        Kode Referral
                                    </div>
                                    <div class="mt-2">
                                        <v-text-field
                                            v-model="referral_code"
                                            variant="flat"
                                            placeholder="Masukkan Kode Referral"
                                            density="compact"
                                            hide-details
                                            clearable
                                            class="bg-white custom-input custom-error"
                                            color="primary"
                                        />
                                    </div>
                                </v-card-text>
                            </v-card>

                            <div class="mt-5 pb-2">
                                <v-btn
                                    v-if="referral_form"
                                    color="#0e97d6"
                                    variant="flat"
                                    rounded="pill"
                                    block
                                    size="large"
                                    :loading="loading_payment"
                                    @click="checkReferralCode()"
                                >
                                    Cek Kode Referral
                                </v-btn>

                                <v-btn
                                    v-else
                                    color="#0e97d6"
                                    variant="flat"
                                    rounded="pill"
                                    block
                                    size="large"
                                    :loading="loading_payment"
                                    @click="sendInvoicePayment()"
                                >
                                    Buat Pesanan
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>

        <v-snackbar
            v-model="snackbar.open"
            :timeout="3000"
            location="top"
            :color="snackbar.color || 'red'"
        >
            {{ snackbar.text }}

            <template v-slot:actions>
                <v-btn
                    color="white"
                    variant="text"
                    @click="snackbar.open = false"
                >
                    Tutup
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import CardPackage from './components/CardPackage.vue';
import Cookies from 'js-cookie';

export default {
    inject: ['display'],
    components: {
        CardPackage,
    },
    data() {
        return {
            isFormValid: false,
            activePanel: 'panel1',
            loading: false,
            loading_payment: false,
            detail: null,
            payment_scheme: null,
            liveclass_schedulle: null,
            list_liveclass_schedulle: [],
            referral_code: null,
            form: {
                student_name: null,
                student_phone: null,
                student_email: null,
                grade: null,
                level: null,
                student_school_name: null,
                parent_name: null,
                parent_email: null,
                parent_wa: null,
                payment_scheme: null,
                register_information_source: null,
            },
            levels: [
                { id: 'SD', text: 'SD' },
                { id: 'SMP', text: 'SMP' },
                { id: 'SMA', text: 'SMA' },
            ],
            gradeOptions: {
                SD: [1, 2, 3, 4, 5, 6],
                SMP: [7, 8, 9],
                SMA: [10, 11, 12],
            },
            sources_information: [
                'Instagram Skolla',
                'Tiktok Skolla',
                'Twitter Skolla',
                'Sales Skolla',
                'Website Skolla',
            ],
            rules: {
                required: [(v) => !!v || 'Wajib diisi'],
            },
            referral_status: null,
            referral_form: false,
            snackbar: {
                open: false,
                text: false,
            },
        };
    },

    computed: {
        package_id() {
            return this.$route.query.id;
        },

        package_discount() {
            const normal_price = this.detail?.normal_price;
            const discount = this.detail?.discount;
            const discount_amount = (normal_price * discount) / 100;

            return normal_price
                ? discount_amount.toLocaleString('id-ID', {
                      maximumFractionDigits: 0,
                  })
                : 0;
        },

        grades() {
            return this.form.level ? this.gradeOptions[this.form.level] : [];
        },

        discount_status() {
            const discount = this.detail?.discount;
            const discount_exp_time = this.detail?.discount_exp_time;
            const now = this.$moment();
            let status = true;

            if (discount_exp_time) {
                if (this.$moment(discount_exp_time).isAfter(now)) {
                    status = true;
                } else {
                    status = false;
                }
            }

            if (!discount) {
                status = false;
            }

            return status;
        },

        actual_price() {
            let actual_price = this.discount_status
                ? this.detail?.actual_price
                : this.detail?.normal_price;

            if (this.referral_status && this.detail?.referral_discount) {
                actual_price =
                    this.detail?.actual_price - this.detail?.referral_discount;
            }

            return actual_price;
        },

        tribun_source_status() {
            const ref = Cookies.get('url_referrer_source') || '';
            // ref.includes('tribunnews')

            return ref;
        },
    },

    watch: {
        'form.level': function () {
            this.form.grade = null;
        },

        referral_code(val) {
            this.referral_status = false;
            this.referral_form = val ? true : false;
        },
    },

    mounted() {
        this.getPackageDetail();
    },

    methods: {
        async getPackageDetail() {
            this.loading = true;
            try {
                this.detail = await this.$axios.get(
                    `payment/package/${this.package_id}/detail/wp`
                );

                this.list_liveclass_schedulle = this.detail?.package_group;

                this.checkReferralCodeCookies();
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async sendInvoicePayment() {
            const check = await this.$refs.form.validate();

            if (!check.valid) {
                this.snackbar = {
                    open: true,
                    text: 'Lengkapi isian detail pembeli terlebih dahulu!',
                };

                return;
            }

            if (this.checkForm()) {
                this.snackbar = {
                    open: true,
                    text: 'Pilih skema bayar terlebih dahulu!',
                };

                return;
            }

            if (!this.form.payment_scheme) {
                this.snackbar = {
                    open: true,
                    text: 'Pilih skema bayar terlebih dahulu!',
                };

                return;
            }

            // generated id untuk url referrer
            this.form.generated_id = Cookies.get('url_referrer_generated_id');
            this.form.referral_code = this.referral_code || null;

            this.loading_payment = true;

            try {
                await this.$axios.post(
                    `payment/transaction/full/inquiry/${this.package_id}/wp`,
                    this.form
                );
                this.setLocalStorage();
                this.$router.push(`/invoice-pembelian?id=${this.package_id}`);
            } catch (error) {
                console.error(error);
                alert('Tidak dapat membuat pesanan untuk saat ini');
            } finally {
                this.loading_payment = false;
            }
        },

        async checkReferralCode() {
            this.loading_payment = true;

            if (!this.checkReferralCodeTribun()) {
                this.snackbar = {
                    open: true,
                    text: 'Kode referral tidak berlaku untuk paket yang dipilih',
                };

                this.loading_payment = false;
                return false;
            }

            try {
                const response = await this.$axios.get(
                    `payment/referral-code/check/${this.referral_code}/wp?package_id=${this.package_id}`
                );

                this.referral_status = response.body.status;

                if (response.statusCodeValue === 200) {
                    this.snackbar = {
                        open: true,
                        color: 'green',
                        text: 'Kode referral berhasil digunakan',
                    };

                    this.referral_form = false;
                } else if (response.statusCodeValue === 403) {
                    this.snackbar = {
                        open: true,
                        text: 'Kode referral tidak berlaku untuk paket yang dipilih',
                    };
                } else {
                    this.snackbar = {
                        open: true,
                        text: 'Kode referral yang kamu masukan tidak tersedia untuk saat ini',
                    };
                }
            } catch (error) {
                console.error(error);

                this.snackbar = {
                    open: true,
                    text: 'Kode referral yang kamu masukan tidak tersedia untuk saat ini',
                };
            } finally {
                this.loading_payment = false;
            }
        },

        formatNumber(val = 0) {
            return val.toLocaleString('id-ID');
        },

        toTop() {
            if (this.display.mdAndUp.value) {
                window.scrollTo({
                    top: 100,
                });
            } else {
                window.scrollTo({
                    top: 1000,
                });
            }
        },

        onlyNumber(event) {
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        },

        normalizeWaNumber(field) {
            if (this.form[field]?.startsWith('0')) {
                this.form[field] = this.form[field].replace(/^0+/, '');
            }
        },

        checkForm() {
            if (!this.form.parent_wa || !this.form.parent_name) {
                return true;
            } else {
                return false;
            }
        },

        setLocalStorage() {
            localStorage.setItem('purchase_user', JSON.stringify(this.form));
            localStorage.setItem('purchase_package', this.package_id);

            this.referral_status
                ? localStorage.setItem(
                      'purchase_referral_code',
                      this.referral_code
                  )
                : localStorage.removeItem('purchase_referral_code');
        },

        checkReferralCodeCookies() {
            const referral_code = Cookies.get('url_referrer_referral_code');

            if (referral_code && this.tribun_source_status) {
                this.referral_code = referral_code;
            }
        },

        checkReferralCodeTribun() {
            var status = true;

            if (
                this.referral_code.includes('tribun') &&
                !this.tribun_source_status
            ) {
                status = false;
            }

            return status;
        },
    },
};
</script>

<style>
.v-expansion-panel__shadow {
    box-shadow: none !important;
}

.custom-radio .v-selection-control__input {
    margin-top: -20px !important;
}

.sticky-col {
    position: sticky !important;
    top: 70px;
    align-self: flex-start;
}
</style>
